import { render, staticRenderFns } from "./PlacementStatistics.vue?vue&type=template&id=989db1be"
import script from "./PlacementStatistics.vue?vue&type=script&lang=js"
export * from "./PlacementStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports